import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  clear(event) {
    event.preventDefault()

    window.location.href = this.formTarget.action
  }

}
